const getSmartScriptUrl = ({oneLinkURL, pageName, campaignSuffix}) => {
  const APP_SUGGESTION_KEY = 'mt-smartbanner'

  const mediaSource = {defaultValue: APP_SUGGESTION_KEY}
  const campaign = {
    keys: ['utm_campaign'],
    defaultValue: [APP_SUGGESTION_KEY, pageName, campaignSuffix].filter(Boolean).join('_')
  }
  const customSsUi = {paramKey: 'af_ss_ui', defaultValue: 'true'}

  try {
    const result = window.AF_SMART_SCRIPT.generateOneLinkURL({
      oneLinkURL,
      afParameters: {
        mediaSource,
        campaign,
        afCustom: [customSsUi]
      }
    })

    return result
  } catch (error) {
    console.error('Error generating SmartScript URL:', error)
  }
}

export {getSmartScriptUrl}
